import { z, type ZodType } from '@customerio/hydra-validation';
import type { Template as ApiTemplate } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/**
 * Template entity — workspace-scoped message templates.
 *
 * Minimal detail-only entity: `id` normalized to `string` (the wire ships a
 * number). The epoch `created`/`updated` timestamps are left untransformed
 * and a list+mutation surface can be added when a consumer needs them.
 */
export type Template = Omit<ApiTemplate, 'id'> & { id: string };

// oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
const TemplateFromApi = z.looseObject({
  id: z.number().transform(String),
}) as unknown as ZodType<Template, unknown>;

/** @public */
export const template = defineEntity<Template>({
  name: 'template',
  scope: 'workspace',
  pk: (t) => t.id,
  schema: { read: TemplateFromApi },
});

export const templateKeys = template.keys;

export function parseTemplate(raw: ApiTemplate): Template {
  return template.parse(raw);
}
